export type SnippetTagsParams = {
  id?: string;
  events?: object;
  dataLayer?: unknown[];
  dataLayerName?: string;
  preview?: string;
  auth?: string;
  gtmCookiesWin?: string;
};

const Snippets = {
  tags: function ({
    id,
    events,
    dataLayer,
    dataLayerName,
    preview,
    auth,
    gtmCookiesWin,
  }: SnippetTagsParams) {
    const gtm_auth = auth ? `&gtm_auth=${auth}` : '';
    const gtm_preview = preview ? `&gtm_preview=${preview}` : '';
    const gtm_cookies_win = gtmCookiesWin
      ? `&gtm_cookies_win=${gtmCookiesWin}`
      : '';

    if (!id) console.warn('GTM Id is required');

    const script = `
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js', ${
          events ? JSON.stringify(events).slice(1, -1) : ''
        }});
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', '${dataLayerName}', '${id}');
      `;

    const iframe = `<iframe
      src="https://www.googletagmanager.com/ns.html?id=${id}${gtm_auth}${gtm_preview}${gtm_cookies_win}"
      height="0"
      width="0"
      style="display: none; visibility: hidden"
      id="tag-manager"
      ></iframe>`;

    const dataLayerVar = this.dataLayer(dataLayer, dataLayerName);

    const onetrustHead = `
    <script
      type="text/javascript"
      src="https://cdn.cookielaw.org/consent/0195f2bf-e314-78f9-8e38-6d2b36ae3c5f/OtAutoBlock.js"
    ></script>
    <script
      src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
      type="text/javascript"
      charset="UTF-8"
      data-domain-script="0195f2bf-e314-78f9-8e38-6d2b36ae3c5f"
    ></script>
    <script type="text/javascript">
      function OptanonWrapper() {}
    </script>
    <!-- OneTrust Cookies Consent Notice end for onesearch.performics.com -->
`;

    const onetrustHeaders = () => {
      const scripts: HTMLScriptElement[] = [];

      const script0 = document.createElement('script');
      script0.type = 'text/javascript';
      script0.src =
        'https://cdn.cookielaw.org/consent/0195f2bf-e314-78f9-8e38-6d2b36ae3c5f/OtAutoBlock.js';
      scripts.push(script0);

      const script1 = document.createElement('script');
      script1.type = 'text/javascript';
      script1.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
      script1.setAttribute(
        'data-domain-script',
        '0195f2bf-e314-78f9-8e38-6d2b36ae3c5f'
      );
      scripts.push(script1);

      const script2 = document.createElement('script');
      script2.type = 'text/javascript';
      script2.innerHTML = 'function OptanonWrapper() {}';
      scripts.push(script2);

      const script3 = document.createElement('script');
      script3.type = 'text/javascript';
      script3.src =
        'https://privacyportal-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js';
      script3.id = 'otprivacy-notice-script';
      script3.innerHTML = `settings="eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9wcml2YWN5Tm90aWNlcy9zdGF0cy92aWV3cyIsImNvbnRlbnRBcGlVcmwiOiJodHRwczovL3ByaXZhY3lwb3J0YWwub25ldHJ1c3QuY29tL3JlcXVlc3QvdjEvZW50ZXJwcmlzZXBvbGljeS9kaWdpdGFscG9saWN5L2NvbnRlbnQiLCJtZXRhZGF0YUFwaVVybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9lbnRlcnByaXNlcG9saWN5L2RpZ2l0YWxwb2xpY3kvbWV0YS1kYXRhIn0="`;
      scripts.push(script3);

      return scripts;
    };

    const onetrustFooter = `
      <!-- OneTrust Cookies Settings button start -->
      <button id="ot-sdk-btn" class="ot-sdk-show-settings">
        Cookie Settings
      </button>
      <!-- OneTrust Cookies Settings button end -->
    `;

    return {
      iframe,
      script,
      dataLayerVar,
      onetrustHead,
      onetrustFooter,
      onetrustHeaders,
    };
  },

  dataLayer: function (dataLayer: unknown = '', dataLayerName: string = '') {
    return `
      window.${dataLayerName} = window.${dataLayerName} || [];
      window.${dataLayerName}.push(${JSON.stringify(dataLayer)})`;
  },
};

export default Snippets;
